var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { Button } from "@riseart/common";
var FilterExpandableButton = /* @__PURE__ */ __name(function FilterExpandableButton2(_ref) {
  var isExpanded = _ref.isExpanded, onClick = _ref.onClick, titleShowMore = _ref.titleShowMore, titleShowLess = _ref.titleShowLess;
  var title = isExpanded ? titleShowLess : titleShowMore;
  return /* @__PURE__ */ React.createElement(Button, {
    type: "link",
    linkType: "strong",
    title,
    onClick
  }, title);
}, "FilterExpandableButton");
export {
  FilterExpandableButton
};
